import { createApp } from 'vue'
import AppComponent from './App.vue'
import { createPinia } from 'pinia'
import vueWechatTitle from 'vue-wechat-title'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { getAssetsFile } from './common/utils/util.js'
// import { startBrowseRecord } from "./common/browse-records"
import { isWeixin } from './common/utils'
import tkwx from './common/tkwx.js'
import router from '@/router'
// ! 公共样式引入
import '@/assets/less/index.less'
//! 函数组件样式，需单独引入
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'
import useInstance from './common/utils/useInstance.js'
// window 挂载相关方法、神策埋点等
useInstance()
// 开启浏览器时长统计
// startBrowseRecord({onlyAdd:true})
if (isWeixin()) {
  tkwx.tk_wxInit()
}
// 神策插码初始化
window.tkSensors.init()
const pinia = createPinia().use(piniaPluginPersistedstate)
const app = createApp(AppComponent)
app.config.globalProperties.$getAssetsFile = getAssetsFile

app.use(router).use(pinia).use(vueWechatTitle).mount('#app')
